import { render } from "./VerticalRadioInput.vue?vue&type=template&id=44d356c6&scoped=true&lang=pug"
import script from "./VerticalRadioInput.vue?vue&type=script&lang=js"
export * from "./VerticalRadioInput.vue?vue&type=script&lang=js"

import "./VerticalRadioInput.vue?vue&type=style&index=0&id=44d356c6&scoped=true&lang=scss"

import exportComponent from "/builds/wiwdata/applications/finance-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44d356c6"]])

export default __exports__